import { Bell, Briefcase, MessageSquare, FileText } from "lucide-react";
import { ProviderSignInIntent } from "@/features/signin/provider-signin-search";

export function PitchContent({ intent }: { intent?: ProviderSignInIntent }) {
  const isJobSeeker = intent === ProviderSignInIntent.Jobs;
  const benefits = [
    {
      Icon: isJobSeeker ? Briefcase : MessageSquare,
      title: isJobSeeker
        ? "Jobs that fit your practice"
        : "Connected to your organization",
      description: isJobSeeker
        ? "Explore healthcare jobs and shifts, save your preferences, and connect with organizations that are hiring."
        : "Stay in touch with your team and manage the information you share with your organization.",
    },
    {
      Icon: FileText,
      title: "Your credentials, organized",
      description:
        "Keep medical licenses, certifications, and CME credits together in one secure place.",
    },
    {
      Icon: Bell,
      title: "Stay ahead of renewals",
      description:
        "Credential reminders help you keep track of renewal deadlines.",
    },
  ];

  return (
    <div>
      <p className="text-xs font-medium uppercase tracking-widest text-white/65">
        Saile for healthcare professionals
      </p>
      <h1 className="mt-4 max-w-[16ch] text-4xl font-semibold leading-[1.08] tracking-tight text-white sm:text-5xl">
        {isJobSeeker
          ? "Find your next healthcare job"
          : "Your healthcare workspace"}
      </h1>
      <p className="mt-5 max-w-[42ch] text-base leading-7 text-white/80 sm:text-lg sm:leading-8">
        {isJobSeeker
          ? "Explore opportunities, organize your credentials, and take the next step in your practice."
          : "One place to manage your credentials and stay connected to the people you work with."}
      </p>

      <ul className="mt-9 divide-y divide-white/15 border-y border-white/15">
        {benefits.map(({ Icon, title, description }) => (
          <li
            key={title}
            className="flex items-start gap-4 py-5 sm:gap-5 sm:py-6"
          >
            <span className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-white/10 text-white ring-1 ring-inset ring-white/15">
              <Icon className="size-5" aria-hidden="true" />
            </span>
            <div className="min-w-0 pt-0.5">
              <h2 className="text-base font-semibold leading-6 text-white sm:text-lg">
                {title}
              </h2>
              <p className="mt-1.5 text-sm leading-6 text-white/80 sm:text-base">
                {description}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
